import React from 'react';
import { NavLink } from "react-router-dom";
import * as Icon from 'react-feather';
import { NotificationManager } from '../../helpers/NotificationManager';
import { Screen } from '../App/Screen';
import { OperatorForm } from './Form';
import { EntityService } from '../../services/EntityService';

export class CreateOperatorContainer extends React.Component {
   constructor(props) {
       super(props);

       this.OperatorService = new EntityService("Operators");
       
       this.createOperator = this.createOperator.bind(this);
   }

   createOperator(operator) {
       var model = {
          ...operator
       };

       this.OperatorService.create(model).then(
           response => {
               const operator = response.data;
               this.props.history.push('/operators/edit/' + operator.id);
               NotificationManager.success('The operator ' + operator.firstName + ' ' + operator.surname + ' was created successfully', 'Operator Created');
           },
           response => {
               NotificationManager.error('Operator was not created', 'Error', 1000);
           },
       );
   }

   render() {
       const isLoaded = true;

       // Build the Screen menu.
       // This will be passed to the Screen component so that it can be rendered in the relevant place.
       const screenMenu = (
           <>
               <NavLink  to="/operators" className="btn btn-sm btn-outline-secondary">
                   <Icon.ArrowLeftCircle className="feather" />&nbsp;Back to Operators List
               </NavLink>
           </>
       );

       // Define the setting for the screen loader
       // This object will be passed to the Screen component,
       // Which will determine how and if the loader should be displayed
       const screenLoader = {
           isEnabled: true,
           isLoaded: isLoaded,
           text: "Loading Create Operator Form..."
       };

       return (
           <Screen title="Create Operator" menu={screenMenu} loader={screenLoader}>
               <OperatorForm
                   ref={(el) => this.operatorForm = el}
                   handleSave={this.createOperator}
                   
               />
           </Screen>
       );
   }
}